import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';

// Import des pages
import Home from './pages/Home';
import Contact from './pages/Contact';
import FAQ from './pages/FAQ';
import Equipe from './pages/Equipe';
import Partenaires from './pages/Partenaires';
import Apropos from './pages/Apropos';
import Diagnostic from './pages/Diagnostic';
import Secourisme from './pages/Secourisme';
import App_intro from './App_intro';

// Import des styles
import './index.css';

// Composant pour la page 404
const NotFound = () => (
  <div className="text-center py-20">
    <h1 className="text-6xl font-bold text-gray-900 mb-4">404</h1>
    <p className="text-xl text-gray-600 mb-8">Page non trouvée</p>
    <a
      href="/"
      className="btn-primary inline-block"
    >
      Retour à l'accueil
    </a>
  </div>
);

function App() {
  return (
    <Router>
      <Routes>
        {/* Route d'introduction */}
        <Route path="/" element={<Navigate to="/intro" replace />} />
        <Route path="/intro" element={<App_intro />} />
        
        {/* Routes principales avec Layout */}
        <Route path="/" element={<Layout />}>
          <Route path="home" element={<Home />} />
          <Route path="contact" element={<Contact />} />
          <Route path="faq" element={<FAQ />} />
          <Route path="equipe" element={<Equipe />} />
          <Route path="partenaires" element={<Partenaires />} />
          <Route path="apropos" element={<Apropos />} />
          <Route path="diagnostic" element={<Diagnostic />} />
          <Route path="secourisme" element={<Secourisme />} />
        </Route>

        {/* Route 404 */}
        <Route path="/404" element={<NotFound />} />
        <Route path="*" element={<Navigate to="/404" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
